<h3 *ngIf="!options.isSearching">
    {{ getBranchName(branch) }}
    <span *ngIf="driver" style="margin-right: 10px;"><span class="text-muted me-1"
                                                           style="margin-right: 8px;">|</span>{{ driver.name }}</span>
    <span class="badge  text-bg-secondary me-1"><i class="fas fa-box"></i> {{ shipments.length }}</span>
    <span class="badge  text-bg-success me-1"
          *ngIf="options && options.startDate"
    ><i class="fas fa-calendar-alt"></i> {{options.startDate.format('DD-MM-YYYY')}}</span>

    <span class="me-1"
          *ngIf="options && options.startDate && options.startDate.format('YYYYMMDD') !== options.endDate.format('YYYYMMDD')"
    > - </span>
    <span class="badge  text-bg-success me-1"
          *ngIf="options && options.startDate && options.startDate.format('YYYYMMDD') !== options.endDate.format('YYYYMMDD')"
    ><i class="fas fa-calendar-alt"></i> {{options.endDate.format('DD-MM-YYYY')}}</span>
</h3>

<h3 *ngIf="options.isSearching">Søgning</h3>
<hr style="margin: 10px 0 25px;">

<div class="row">
    <div [ngClass]="{ 'col-md-6': oneDay, 'col-md-12': !oneDay }">
        <div class="pe-3">
            <app-shipping-system-table [shipmentRoute]="null"
                                       [branch]="branch"
                                       [shipmentRoutes]="shipmentRoutes"
                                       [showHeader]="true"
                                       [header]="expandOrderLines||options.isSearching ? 'Ordrer' : 'Indkommende ordre'"
                                       [shipments]="provideDefaultShipments()"
                                       [expandOrderLines]="expandOrderLines"
                                       [sortfield]="sortfield"
                                       [enableTempSorting]="true"
                                       [showDate]="!oneDay"
                                       (shipmentsChanged)="shipmentsChangedCallback()"></app-shipping-system-table>

            <ng-container *ngIf="!options.isSearching">
                <!-- HÅNDTERET DRIVER -->
                <ng-template ngFor let-shipmentRoute [ngForOf]="shipmentRoutes">

                    <div *ngIf="shouldShowRoute(shipmentRoute, true)">
                        <h5 class="branch-driver-headline d-flex justify-content-between" style="
                   background: #000000;
                    margin: 0 -15px; color: #fff; padding: 3px 15px; font-weight: normal; font-size: 18px;">
                    <span>
                        <i (click)="toggleRouteCollapse(shipmentRoute)"
                           class="fas  pe-1"
                           [ngClass]="{ 'fa-sort-down': !collaps[shipmentRoute.branch + '-' + shipmentRoute.driver], 'fa-caret-right': collaps[shipmentRoute.branch + '-' + shipmentRoute.driver] }"
                           style="cursor: pointer;"></i>
                        {{ shipmentRoute.name }}
                    </span>
                        </h5>
                        <div *ngIf="!collaps[shipmentRoute.branch + '-' + shipmentRoute.driver]" class="mb-2">
                            <app-shipping-system-table
                                    [branch]="branch"
                                    [shipmentRoutes]="shipmentRoutes"
                                    [shipmentRouteId]="shipmentRoute.branch + '-' + shipmentRoute.driver"
                                    [shipmentRoute]="shipmentRoute"
                                    [shipments]="routes[shipmentRoute.id]"
                                    [showDate]="true"
                                    [sortfield]="sortfield"
                                    (shipmentsChanged)="shipmentsChangedCallback()"
                                    (routeChanged)="routeChangedCallback($event)"></app-shipping-system-table>
                        </div>
                    </div>
                </ng-template>

                <ng-template ngFor let-shipmentRoute [ngForOf]="shipmentRoutes">

                    <div *ngIf="shouldShowSepcialRoute(shipmentRoute, branch)">
                        <h5 class="branch-driver-headline d-flex justify-content-between" style="
                   background: #000000;
                    margin: 0 -15px; color: #fff; padding: 3px 15px; font-weight: normal; font-size: 18px;">
                    <span>
                        <i (click)="toggleRouteCollapse(shipmentRoute)"
                           class="fas  pe-1"
                           [ngClass]="{ 'fa-sort-down': !collaps[shipmentRoute.branch + '-' + shipmentRoute.driver], 'fa-caret-right': collaps[shipmentRoute.branch + '-' + shipmentRoute.driver] }"
                           style="cursor: pointer;"></i>
                        {{ shipmentRoute.name }}
                    </span>
                        </h5>
                        <div *ngIf="!collaps[shipmentRoute.branch + '-' + shipmentRoute.driver]" class="mb-2">
                            <app-shipping-system-table
                                    [branch]="branch"
                                    [shipmentRoutes]="shipmentRoutes"
                                    [shipmentRouteId]="shipmentRoute.branch + '-' + shipmentRoute.driver"
                                    [shipmentRoute]="shipmentRoute"
                                    [shipments]="problemRoutes[shipmentRoute.id]"
                                    [showDate]="true"
                                    [sortfield]="sortfield"
                                    (shipmentsChanged)="shipmentsChangedCallback()"
                                    (routeChanged)="routeChangedCallback($event)"></app-shipping-system-table>
                        </div>
                    </div>
                </ng-template>
            </ng-container>

        </div>
    </div>

    <div *ngIf="oneDay" [ngClass]="{ 'col-md-6': oneDay, 'col-md-12': !oneDay }">
        <div class="sticky-top" style="flex: 0 1; overflow-x: hidden; overflow-y: scroll; height: 100vh;">
        <div class="d-flex justify-content-between mb-2">
            <h4>Ordre fordelt på ruter</h4>
            <button (click)="toggleCollapse(areAllCollapsed() ? false: true)" class="btn btn-sm btn-outline-primary" i18n>{{areAllCollapsed() ? 'Udvid alle' : 'Kollaps alle'}}</button>
        </div>

        <ng-template ngFor let-shipmentRoute [ngForOf]="shipmentRoutes">
            <div *ngIf="shouldShowRoute(shipmentRoute, false)">
                <h5 *ngIf="shipmentRoute.trip == 1" class="branch-driver-headline d-flex justify-content-between"
                    [ngStyle]="{'background-color': shipmentRoute.route_color}"
                    style="margin: 0 -15px; color: #fff; padding: 3px 15px; font-weight: normal; font-size: 18px;">
                    <span>
                        <i (click)="toggleRouteCollapse(shipmentRoute)"
                           class="fas  pe-1"
                           [ngClass]="{ 'fa-sort-down': !collaps[shipmentRoute.branch + '-' + shipmentRoute.driver], 'fa-caret-right': collaps[shipmentRoute.branch + '-' + shipmentRoute.driver] }"
                           style="cursor: pointer;"></i>
                        <!--                        {{ shipmentRoute.branch }}-->
                        {{ shipmentRoute.name }}
                    </span>

                    <span class="badge  text-bg-secondary"
                          [attr.data-route-driver]="shipmentRoute.branch + '-' + shipmentRoute.driver">{{ driverShipments(shipmentRoute.branch, shipmentRoute.driver) }}
                        forsendelser</span>
                </h5>
                <div *ngIf="!collaps[shipmentRoute.branch + '-' + shipmentRoute.driver]" class="mb-2">
                    <app-shipping-system-table
                            [branch]="branch"
                            [shipmentRoutes]="shipmentRoutes"
                            [sortfield]="sortfield"
                            [shipmentRouteId]="shipmentRoute.branch + '-' + shipmentRoute.driver"
                            [shipmentRoute]="shipmentRoute"
                            [shipments]="routes[shipmentRoute.id]"
                            (shipmentsChanged)="shipmentsChangedCallback()"
                            (routeChanged)="routeChangedCallback($event)"></app-shipping-system-table>
                </div>
            </div>
        </ng-template>
    </div>
    </div>
</div>
